module.exports = __webpack_public_path__ + "img/bottom_opening.aaccf063.png";